import React from "react";
import "./styles.css";

export const VillaDescription = ({ items }) => (
    <div className="ramadan_description-list">
        {items.map((item, index) => (
            <div
                key={index}
                className={`ramadan_description-item ${item.total ? "total" : ""}`}
            >
                <span className="ramadan_description-name">{item.name}</span>
                <span className="ramadan_description-area">{item.area}</span>
            </div>
        ))}
    </div>
);
